import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["categoriesMenu", "userMenu", "categoriesTemplate"]

  connect() {
    this.categoriesHTML = this.categoriesTemplateTarget.content.cloneNode(true)
  }

  closeMenu(e) {
    this.categoriesMenuTarget.dataset.visible = "false"
    this.userMenuTarget.dataset.visible = "false"
  }

  openUserMenu(e) {
    e.preventDefault()

    this.userMenuTarget.dataset.visible = "true"
  }

  openCategoriesMenu(e) {
    e.preventDefault()

    this.categoriesMenuTarget.dataset.visible = "true"
    this.categoriesMenuTarget.append(this.categoriesHTML)
  }
}
